import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Controller, useForm } from "react-hook-form";
import { post,get } from "helpers/api_helper";
import { FILLER_CREATE,FILLER_LIST } from "helpers/url_helper";
import { useNavigate } from "react-router-dom";

const CreateFiller = () => {
  const Navigate = useNavigate();
  const [fillerList, setFillerList] = useState([]);

useEffect(() => {
 const fetchFillers = async () => {
    try {
      const response = await get(FILLER_LIST);
      console.log("FILLER_LIST response:", response);
      setFillerList(response.data?.items || []); // ✅ CORRECT array assignment
    } catch (error) {
      console.error("Failed to fetch fillers", error);
    }
  };

  fetchFillers();
}, []);
  useEffect(() => {
    window.google &&
      window.google.load("elements", "1", {
        packages: "transliteration",
        callback: onLoadTransliteration,
      });

    function onLoadTransliteration() {
      const control =
        new window.google.elements.transliteration.TransliterationControl({
          sourceLanguage:
            window.google.elements.transliteration.LanguageCode.ENGLISH,
          destinationLanguage: [
            window.google.elements.transliteration.LanguageCode.GUJARATI,
          ],
          transliterationEnabled: true,
        });

      control.makeTransliteratable(["name", "address", "notes"]);
    }
  }, []);
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
  } = useForm({
    defaultValues: {
      phone: "",
      name: "",
      email: "",
      password: "",
      nozzle: "",
      remarks: "",
      status: "1",
      address: "",
    },
  });

  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Create Filler", link: "#" },
  ];

  const onSubmit = async (value) => {
    const payload = {
      ...value,
      status: value?.customer_status,
    };

    try {
      const response = await post(FILLER_CREATE, payload);

      toastr.success("Filler created successfully!");
      Navigate("/fillers"); // <-- use the hook, not the component
    } catch (error) {
      toastr.error("Filler creation failed!");
    } finally {
      reset();
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Create Filler"
            breadcrumbItems={breadcrumbItems}
          />
        </Container>
        <Row>
          <Col xl="12">
            <Card>
              <CardBody>
                <Form
                  className="needs-validation"
                  method="post"
                  id="customerCreateForm"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <Row>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="phone">
                          Phone No <span className="text-danger">*</span>
                        </Label>

                        <Controller
                          name="phone"
                          control={control}
                          rules={{
                            required: "Phone number is required",
                            pattern: {
                              value: /^[0-9]*$/, // only numbers
                              message: "Please enter only numbers",
                            },
                            minLength: {
                              value: 10,
                              message: "Must be 10-digits phone number",
                            },
                            maxLength: {
                              value: 10,
                              message: "Must be 10-digits phone number",
                            },
                            validate: (value) =>
                              !fillerList.some((filler) => filler.phone === value) ||
                              "Phone number already exists",
                            }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              id="phone"
                              placeholder="Enter Phone no"
                              type="tel" // opens phone's dial pad
                              inputMode="numeric" // fallback to show numeric keyboard
                              pattern="[0-9]*"
                              maxLength="10"
                              onKeyDown={(e) => {
                                // block non-digits
                                if (
                                  !/[0-9]|Backspace|ArrowLeft|ArrowRight|Tab|Delete/.test(
                                    e.key
                                  )
                                ) {
                                  e.preventDefault();
                                }
                              }}
                              className={`form-control ${
                                errors.phone ? "is-invalid" : ""
                              }`}
                            />
                          )}
                        />
                        {errors.phone?.message && (
                          <div className="text-danger">
                            {errors.phone.message}
                          </div>
                        )}
                      </div>
                    </Col>

                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <label className="form-label" htmlFor="name">
                          {" "}
                          Name 
                        </label>
                        <Controller
                          name="name"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="name"
                              placeholder="Enter name"
                            />
                          )}
                        />
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <label className="form-label" htmlFor="email">
                          {" "}
                          email 
                        </label>
                        <Controller
                          name="email"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="email"
                              placeholder="Enter email"
                            />
                          )}
                        />
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <label className="form-label" htmlFor="password">
                          {" "}
                          Password <span className="text-danger">*</span>
                        </label>
                        <Controller
                          name="password"
                          control={control}
                          rules={{
                            required: "password is required",
                          }}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="password"
                              className={`form-control ${
                                errors.password ? "is-invalid" : ""
                              }`}
                              id="password"
                              placeholder="Enter password"
                            />
                          )}
                        />
                        {errors.password?.message && (
                          <div className="text-danger">
                            {errors.password.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    {/* <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="nozzle">
                          Nozzle
                        </Label>
                        <Controller
                          name="nozzle"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.nozzle ? "is-invalid" : ""
                              }`}
                              id="nozzle"
                              placeholder="Enter Nozzle Number"
                            />
                          )}
                        />
                        {errors.nozzle?.message && (
                          <div className="text-danger">
                            {errors.nozzle.message}
                          </div>
                        )}
                      </div>
                    </Col> */}
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="Salary">
                          Salary
                        </Label>
                        <Controller
                          name="Liter"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="text"
                              className={`form-control ${
                                errors.email ? "is-invalid" : ""
                              }`}
                              id="Salary"
                              placeholder="Enter Salary"
                            />
                          )}
                        />
                        {errors.email?.message && (
                          <div className="text-danger">
                            {errors.email.message}
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md="6" xl="4">
                      <div className="mb-3 position-relative">
                        <Label className="form-label" htmlFor="Remarks">
                          Remarks
                        </Label>
                        <Controller
                          name="Remarks"
                          control={control}
                          render={({ field }) => (
                            <Input
                              {...field}
                              type="textarea"
                              style={{ height: "80px" }}
                              className={`form-control9 `}
                              id="Remarks"
                              placeholder="Enter Remarks"
                            />
                          )}
                        />
                      </div>
                    </Col>
                  </Row>
                   <div className="text-end">
                      <Button type="submit" color="primary" disabled={isSubmitting}>
                          {isSubmitting ? "Submitting..." : "Submit"}
                        </Button>
                    </div>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default CreateFiller;
// import React, { useEffect } from "react";
